export default "__VITE_ASSET__CAOHLCi1__"